import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-522f6584"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "home__img",
  src: "/heroSection.jpg",
  alt: "shoes__heroSection"
}, null, -1))
const _hoisted_3 = { class: "homeJoin" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "homeJoin__title" }, "JOIN OUR SneakersClub & GET 15% OFF", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "homeJoin__para" }, "Be the first to get the latest news about trends, promotions and much more!", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeModalAuth && _ctx.changeModalAuth(...args))),
        class: "homeJoin__btn"
      }, "Sign for free -->")
    ])
  ]))
}